module.exports = __webpack_public_path__ + "img/signup-doctor.337685ec.svg";